import { useTranslation } from 'react-i18next'

import { useQueryClient } from '@tanstack/react-query'
import Text from '@web-ui-kit/text'
import Link from '@web-ui-kit/link'
import * as Sc from './SatisfactionSurveyNotification.style'
import { IconSurvey } from 'assets/icons/IconSurvey'
import { TYPE_FEEDBACKS_ACTIONS } from 'utils/constants'
import { STATUS_FLAGS } from 'utils/constants/flags'
import { USER_KEYS, usePostUserFeedbackPool } from 'hooks/user'
import { TYPES_LANGUAGES } from 'utils/constants/languages'
import useCheckCanary from 'hooks/useCheckCanary'

const SatisfactionSurveyNotification = () => {
  const { t, i18n } = useTranslation()
  const queryClient = useQueryClient()
  const { mutate: mutateFeedbacksPools } = usePostUserFeedbackPool()
  const showNewAlertCenter = useCheckCanary(
    window?.rebranding?.canaryUsers,
    window?.rebranding?.enableAlerteCenter
  )
  const { surveyUrl_ca, surveyUrl_es } = window.satisfactionSurvey || {}

  const handleOnClickLink = () => {
    mutateFeedbacksPools(TYPE_FEEDBACKS_ACTIONS.POOL_STARTED)
    queryClient.setQueryData([USER_KEYS.GET_USER], (oldData) => {
      return {
        ...oldData,
        userFlags: {
          ...oldData.userFlags,
          FEEDBACK_POOL_LATER: STATUS_FLAGS.FALSE,
        },
      }
    })
    const surveyUrl =
      i18n.language === TYPES_LANGUAGES.CA_ES ? surveyUrl_ca : surveyUrl_es
    window.open(surveyUrl, '_blank', 'noreferrer')
  }
  const Description = showNewAlertCenter ? Text : Sc.Description
  const Title = showNewAlertCenter ? Text : Sc.Title
  return (
    <Sc.Container $isRebranding={showNewAlertCenter}>
      <Sc.TitleContainer>
        {!showNewAlertCenter && <IconSurvey />}
        <Title bold={showNewAlertCenter} variant={'body'}>
          {t('¡Tu opinión cuenta!')}
        </Title>
      </Sc.TitleContainer>
      <Text variant={'small'}>
        {t(
          'Ayúdanos a mejorar nuestra plataforma respondiendo a este breve cuestionario'
        )}
      </Text>
      <Description bold={showNewAlertCenter} variant='small'>
        {t('El cuestionario estará activo hasta el 30 de junio')}
      </Description>
      {showNewAlertCenter ? (
        <Link
          dataTestId='link-survey-submit'
          onClick={handleOnClickLink}
          role='link'
          size='small'
        >
          {t('Hacer cuestionario')}
        </Link>
      ) : (
        <Sc.Link
          dataTestId='link-survey-submit'
          onClick={handleOnClickLink}
          small
          text={t('Hacer cuestionario')}
          variant='link'
        />
      )}
    </Sc.Container>
  )
}

export default SatisfactionSurveyNotification
